<template>
<div>
  <div class="card card--white">
    <div class="header">
      <h1 class="flex-center" style="background-color: gray">
        <i class="material-icons">cloud</i>
        word cloud
      </h1>
    </div>
    <div class="container">
      <div v-if="!loading && blob.length > 5">
        <wordcloud
          :data="blob"
          nameKey="name"
          valueKey="value"
          class="wordcloud"
          :wordClick="wordClick">
        </wordcloud>
      </div>
      <div v-else-if="loading" >
        Loading <v-progress-circular v-if="loading" :value="40" class="loading" indeterminate color="orange"></v-progress-circular>
      </div>
      <div v-else class="section">
        Not enough data to display a word cloud
      </div>
    </div>
  </div>
</div>
</template>

<script>
import wordcloud from "vue-wordcloud";
import axios from "axios";

export default {
  props: ["endPoint"],
  data() {
    return {
      days: "",
      where: "",
      below: "",
      displayFilter: false,
      day_options: [
        {value: "", string: ""},
        {value: 10, string: "10 Days"},
        {value: 30, string: "30 Days"},
        {value: 90, string: "90 Days"},
        {value: 180, string: "180 Days"},
        {value: 365, string: "Year"},
      ],
      where_options: ["", "1", "2", "3", "4", "5", "6", "7"],
      above_or_below: ["", "Above", "Below"],
      blob: [],
      loading: false 
    };
  },
  created() {
    this.first = true;
    this.filter();
  },
  components: {
    wordcloud
  },
  methods: {
    wordClick(word) {
      this.$emit('wordClick', word);
    },
    filter() {
      this.loading = true;
      axios.get(this.endPoint, {params: {since: this.days, where: this.where, below: this.below}}).then(({ data }) => {
        this.blob = Object.keys(data.blob).map(key => {
          return { name: key, value: data.blob[key] };
        });
        if (this.first && this.blob.length >= 5) {
          this.displayFilter = true;
        }
      }).finally(() => {
        this.first = false;
        this.loading = false;
        this.$emit("finished");
      }); 
    }
  }
};
</script>

<style lang="less" scoped>
.filter {
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: 500px;
  float: right;
  .filter-by {
    width: 140px;
  }

}
.wordcloud {
 cursor: pointer;
}
</style>
